module.exports = __webpack_public_path__ + "img/subcrp1_1.1abba348.png";